import type { FormField, FormSchema } from '@cli-types/core-engine/schema.js'

export function getAllFormSchemaFields(schema: FormSchema): FormField[] {
  const flatten = (fields: FormField[]): FormField[] => {
    return fields.flatMap((field) => {
      if (field.type === 'dynamicFields') return []
      if (field.type === 'group' && field.fields) return flatten(field.fields)
      return field.type === 'group' ? [] : [field]
    })
  }
  if (schema.fields) return flatten(schema.fields)
  if (schema.steps) return schema.steps.flatMap((step) => flatten(step.fields))
  return []
}
